import { render, staticRenderFns } from "./_dropzone.vue?vue&type=template&id=4d716b7a&"
import script from "./_dropzone.vue?vue&type=script&lang=js&"
export * from "./_dropzone.vue?vue&type=script&lang=js&"
import style0 from "./_dropzone.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports